import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import {
  FileTextOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { space, radius, shadow, text } from '../../configs/designTokens';

const cardStyle = {
  borderRadius: radius.lg,
  boxShadow: shadow.sm,
  height: '100%',
};

const AnalyticsMetricCards = ({ metrics, loading }) => {
  const cards = [
    {
      key: 'total',
      title: 'Total Tasks',
      value: metrics.total,
      icon: <FileTextOutlined style={{ color: '#3b82f6' }} />,
      color: '#3b82f6',
    },
    {
      key: 'completed',
      title: 'Completed',
      value: metrics.completed,
      icon: <CheckCircleOutlined style={{ color: '#22c55e' }} />,
      color: '#22c55e',
    },
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: space[6] }}>
      {cards.map((card) => (
        <Col xs={12} sm={8} md={6} lg={4} key={card.key}>
          <Card style={cardStyle} bodyStyle={{ padding: space[4] }} loading={loading}>
            <div style={{ display: 'flex', alignItems: 'center', gap: space[2], marginBottom: space[2] }}>
              {card.icon}
              <span style={{ fontSize: 12, color: text.label }}>{card.title}</span>
            </div>
            <Statistic
              value={card.value}
              suffix={card.suffix}
              valueStyle={{
                fontSize: 28,
                fontWeight: 600,
                color: card.color,
              }}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AnalyticsMetricCards;
